/* globals */
'use strict';

/**
 * @typedef {Object} CONSTSTYPES
 */

/**
 * 3D Crossword Plugin
 */
export const x3d = 'application/vnd.hzn-3d-crossword';

/**
 * 3GP
 */
export const _3gp = 'video/3gpp';

/**
 * 3GP2
 */
export const _3g2 = 'video/3gpp2';

/**
 * 3GPP MSEQ File
 */
export const mseq = 'application/vnd.mseq';

/**
 * 3M Post It Notes
 */
export const pwn = 'application/vnd.3m.post-it-notes';

/**
 * 3rd Generation Partnership Project - Pic Large
 */
export const plb = 'application/vnd.3gpp.pic-bw-large';

/**
 * 3rd Generation Partnership Project - Pic Small
 */
export const psb = 'application/vnd.3gpp.pic-bw-small';

/**
 * 3rd Generation Partnership Project - Pic Var
 */
export const pvb = 'application/vnd.3gpp.pic-bw-var';

/**
 * 3rd Generation Partnership Project - Transaction Capabilities Application Part
 */
export const tcap = 'application/vnd.3gpp2.tcap';

/**
 * 7-Zip
 */
export const _7z = 'application/x-7z-compressed';

/**
 * AbiWord
 */
export const abw = 'application/x-abiword';

/**
 * Ace Archive
 */
export const ace = 'application/x-ace-compressed';

/**
 * Active Content Compression
 */
export const acc = 'application/vnd.americandynamics.acc';

/**
 * ACU Cobol
 */
export const acu = 'application/vnd.acucobol';

/**
 * ACU Cobol
 */
export const atc = 'application/vnd.acucorp';

/**
 * Adaptive differential pulse-code modulation
 */
export const adp = 'audio/adpcm';

/**
 * Adobe (Macropedia) Authorware - Binary File
 */
export const aab = 'application/x-authorware-bin';

/**
 * Adobe (Macropedia) Authorware - Map
 */
export const aam = 'application/x-authorware-map';

/**
 * Adobe (Macropedia) Authorware - Segment File
 */
export const aas = 'application/x-authorware-seg';

/**
 * Adobe AIR Application
 */
export const air = 'application/vnd.adobe.air-application-installer-package+zip';

/**
 * Adobe Flash
 */
export const swf = 'application/x-shockwave-flash';

/**
 * Adobe Flex Project
 */
export const fxp = 'application/vnd.adobe.fxp';

/**
 * Adobe Portable Document Format
 */
export const pdf = 'application/pdf';

/**
 * Adobe PostScript Printer Description File Format
 */
export const ppd = 'application/vnd.cups-ppd';

/**
 * Adobe Shockwave Player
 */
export const dir = 'application/x-director';

/**
 * Adobe XML Data Package
 */
export const xdp = 'application/vnd.adobe.xdp+xml';

/**
 * Adobe XML Forms Data Format
 */
export const xfdf = 'application/vnd.adobe.xfdf';

/**
 * Advanced Audio Coding (AAC)
 */
export const aac = 'audio/x-aac';

/**
 * Ahead AIR Application
 */
export const ahead = 'application/vnd.ahead.space';

/**
 * AirZip FileSECURE
 */
export const azf = 'application/vnd.airzip.filesecure.azf';

/**
 * AirZip FileSECURE
 */
export const azs = 'application/vnd.airzip.filesecure.azs';

/**
 * Amazon Kindle eBook format
 */
export const azw = 'application/vnd.amazon.ebook';

/**
 * AmigaDE
 */
export const ami = 'application/vnd.amiga.ami';

/**
 * Andrew Toolkit
 */
export const atool = 'application/andrew-inset';

/**
 * Android Package Archive
 */
export const apk = 'application/vnd.android.package-archive';

/**
 * ANSER-WEB Terminal Client - Certificate Issue
 */
export const cii = 'application/vnd.anser-web-certificate-issue-initiation';

/**
 * ANSER-WEB Terminal Client - Web Funds Transfer
 */
export const fti = 'application/vnd.anser-web-funds-transfer-initiation';

/**
 * Antix Game Player
 */
export const atx = 'application/vnd.antix.game-component';

/**
 * Apple Installer Package
 */
export const mpkg = 'application/vnd.apple.installer+xml';

/**
 * Applixware
 */
export const aw = 'application/applixware';

/**
 * Archipelago Lesson Player
 */
export const les = 'application/vnd.hhe.lesson-player';

/**
 * Arista Networks Software Image
 */
export const swi = 'application/vnd.aristanetworks.swi';

/**
 * Assembler Source File
 */
export const s = 'text/x-asm';

/**
 * Atom Publishing Protocol
 */
export const atomcat = 'application/atomcat+xml';

/**
 * Atom Publishing Protocol Service Document
 */
export const atomsvc = 'application/atomsvc+xml';

/**
 * Atom Syndication Format
 */
export const atom = 'application/atom+xml';

/**
 * Attribute Certificate
 */
export const ac = 'application/pkix-attr-cert';

/**
 * Audio Interchange File Format
 */
export const aif = 'audio/x-aiff';

/**
 * Audio Video Interleave (AVI)
 */
export const avi = 'video/x-msvideo';

/**
 * Audiograph
 */
export const aep = 'application/vnd.audiograph';

/**
 * AutoCAD DXF
 */
export const dxf = 'image/vnd.dxf';

/**
 * Autodesk Design Web Format (DWF)
 */
export const dwf = 'model/vnd.dwf';

/**
 * BAS Partitur Format
 */
export const par = 'text/plain-bas';

/**
 * Binary CPIO Archive
 */
export const bcpio = 'application/x-bcpio';

/**
 * Binary Data
 */
export const bin = 'application/octet-stream';

/**
 * BitTorrent
 */
export const torrent = 'application/x-bittorrent';

/**
 * Blackberry COD File
 */
export const cod = 'application/vnd.rim.cod';

/**
 * BMI Drawing Data Interchange
 */
export const bmi = 'application/vnd.bmi';

/**
 * Bourne Shell Script
 */
export const sh = 'application/x-sh';

/**
 * BTIF
 */
export const btif = 'image/prs.btif';

/**
 * BusinessObjects
 */
export const rep = 'application/vnd.businessobjects';

/**
 * Bzip Archive
 */
export const bz = 'application/x-bzip';

/**
 * Bzip2 Archive
 */
export const bz2 = 'application/x-bzip2';

/**
 * C Shell Script
 */
export const csh = 'application/x-csh';

/**
 * C Source File
 */
export const c = 'text/x-c';

/**
 * CambridgeSoft Chem Draw
 */
export const cdxml = 'application/vnd.chemdraw+xml';

/**
 * Cascading Style Sheets (CSS)
 */
export const css = 'text/css';

/**
 * ChemDraw eXchange file
 */
export const cdx = 'chemical/x-cdx';

/**
 * Chemical Markup Language
 */
export const cml = 'chemical/x-cml';

/**
 * Chemical Style Markup Language
 */
export const csml = 'chemical/x-csml';

/**
 * CIM Database
 */
export const cdbcmsg = 'application/vnd.contact.cmsg';

/**
 * Claymore Data Files
 */
export const cla = 'application/vnd.claymore';

/**
 * Clonk Game
 */
export const c4g = 'application/vnd.clonk.c4group';

/**
 * Close Captioning - Subtitle
 */
export const sub = 'image/vnd.dvb.subtitle';

/**
 * Cloud Data Management Interface (CDMI) - Capability
 */
export const cdmia = 'application/cdmi-capability';

/**
 * Cloud Data Management Interface (CDMI) - Contaimer
 */
export const cdmic = 'application/cdmi-container';

/**
 * Cloud Data Management Interface (CDMI) - Domain
 */
export const cdmid = 'application/cdmi-domain';

/**
 * Cloud Data Management Interface (CDMI) - Object
 */
export const cdmio = 'application/cdmi-object';

/**
 * Cloud Data Management Interface (CDMI) - Queue
 */
export const cdmiq = 'application/cdmi-queue';

/**
 * ClueTrust CartoMobile - Config
 */
export const c11amc = 'application/vnd.cluetrust.cartomobile-config';

/**
 * ClueTrust CartoMobile - Config Package
 */
export const c11amz = 'application/vnd.cluetrust.cartomobile-config-pkg';

/**
 * CMU Image
 */
export const ras = 'image/x-cmu-raster';

/**
 * Comma-Seperated Values
 */
export const csv = 'text/csv';

/**
 * Compact Pro
 */
export const cpt = 'application/mac-compactpro';

/**
 * Compiled Wireless Markup Language (WMLC)
 */
export const wmlc = 'application/vnd.wap.wmlc';

/**
 * Computer Graphics Metafile
 */
export const cgm = 'image/cgm';

/**
 * CoolTalk
 */
export const ice = 'x-conference/x-cooltalk';

/**
 * Corel Metafile Exchange (CMX)
 */
export const cmx = 'image/x-cmx';

/**
 * CorelXARA
 */
export const xar = 'application/vnd.xara';

/**
 * CosmoCaller
 */
export const cmc = 'application/vnd.cosmocaller';

/**
 * CPIO Archive
 */
export const cpio = 'application/x-cpio';

/**
 * CrickSoftware - Clicker
 */
export const clkx = 'application/vnd.crick.clicker';

/**
 * CrickSoftware - Clicker - Keyboard
 */
export const clkk = 'application/vnd.crick.clicker.keyboard';

/**
 * CrickSoftware - Clicker - Palette
 */
export const clkp = 'application/vnd.crick.clicker.palette';

/**
 * CrickSoftware - Clicker - Template
 */
export const clkt = 'application/vnd.crick.clicker.template';

/**
 * CrickSoftware - Clicker - Wordbank
 */
export const clkw = 'application/vnd.crick.clicker.wordbank';

/**
 * Critical Tools - PERT Chart EXPERT
 */
export const wbs = 'application/vnd.criticaltools.wbs+xml';

/**
 * CryptoNote
 */
export const cryptonote = 'application/vnd.rig.cryptonote';

/**
 * Crystallographic Interchange Format
 */
export const cif = 'chemical/x-cif';

/**
 * CrystalMaker Data Format
 */
export const cmdf = 'chemical/x-cmdf';

/**
 * CU-SeeMe
 */
export const cu = 'application/cu-seeme';

/**
 * CU-Writer
 */
export const cww = 'application/prs.cww';

/**
 * Curl - Detached Applet
 */
export const dcurl = 'text/vnd.curl.dcurl';

/**
 * Curl - Manifest File
 */
export const mcurl = 'text/vnd.curl.mcurl';

/**
 * Curl - Source Code
 */
export const scurl = 'text/vnd.curl.scurl';

/**
 * CURL Applet
 */
export const car = 'application/vnd.curl.car';

/**
 * CURL Applet
 */
export const pcurl = 'application/vnd.curl.pcurl';

/**
 * CustomMenu
 */
export const cmp = 'application/vnd.yellowriver-custom-menu';

/**
 * Data Structure for the Security Suitability of Cryptographic Algorithms
 */
export const dssc = 'application/dssc+der';

/**
 * Data Structure for the Security Suitability of Cryptographic Algorithms
 */
export const xdssc = 'application/dssc+xml';

/**
 * Debian Package
 */
export const deb = 'application/x-debian-package';

/**
 * DECE Audio
 */
export const uva = 'audio/vnd.dece.audio';

/**
 * DECE Graphic
 */
export const uvi = 'image/vnd.dece.graphic';

/**
 * DECE High Definition Video
 */
export const uvh = 'video/vnd.dece.hd';

/**
 * DECE Mobile Video
 */
export const uvm = 'video/vnd.dece.mobile';

/**
 * DECE MP4
 */
export const uvu = 'video/vnd.uvvu.mp4';

/**
 * DECE PD Video
 */
export const uvp = 'video/vnd.dece.pd';

/**
 * DECE SD Video
 */
export const uvs = 'video/vnd.dece.sd';

/**
 * DECE Video
 */
export const uvv = 'video/vnd.dece.video';

/**
 * Device Independent File Format (DVI)
 */
export const dvi = 'application/x-dvi';

/**
 * Digital Siesmograph Networks - SEED Datafiles
 */
export const seed = 'application/vnd.fdsn.seed';

/**
 * Digital Talking Book
 */
export const dtb = 'application/x-dtbook+xml';

/**
 * Digital Talking Book - Resource File
 */
export const res = 'application/x-dtbresource+xml';

/**
 * Digital Video Broadcasting
 */
export const ait = 'application/vnd.dvb.ait';

/**
 * Digital Video Broadcasting
 */
export const svc = 'application/vnd.dvb.service';

/**
 * Digital Winds Music
 */
export const eol = 'audio/vnd.digital-winds';

/**
 * DjVu
 */
export const djvu = 'image/vnd.djvu';

/**
 * Document Type Definition
 */
export const dtd = 'application/xml-dtd';

/**
 * Dolby Meridian Lossless Packing
 */
export const mlp = 'application/vnd.dolby.mlp';

/**
 * Doom Video Game
 */
export const wad = 'application/x-doom';

/**
 * DPGraph
 */
export const dpg = 'application/vnd.dpgraph';

/**
 * DRA Audio
 */
export const dra = 'audio/vnd.dra';

/**
 * DreamFactory
 */
export const dfac = 'application/vnd.dreamfactory';

/**
 * DTS Audio
 */
export const dts = 'audio/vnd.dts';

/**
 * DTS High Definition Audio
 */
export const dtshd = 'audio/vnd.dts.hd';

/**
 * DWG Drawing
 */
export const dwg = 'image/vnd.dwg';

/**
 * DynaGeo
 */
export const geo = 'application/vnd.dynageo';

/**
 * ECMAScript
 */
export const es = 'application/ecmascript';

/**
 * EcoWin Chart
 */
export const mag = 'application/vnd.ecowin.chart';

/**
 * EDMICS 2000
 */
export const mmr = 'image/vnd.fujixerox.edmics-mmr';

/**
 * EDMICS 2000
 */
export const rlc = 'image/vnd.fujixerox.edmics-rlc';

/**
 * Efficient XML Interchange
 */
export const exi = 'application/exi';

/**
 * EFI Proteus
 */
export const mgz = 'application/vnd.proteus.magazine';

/**
 * Electronic Publication
 */
export const epub = 'application/epub+zip';

/**
 * Email Message
 */
export const eml = 'message/rfc822';

/**
 * Enliven Viewer
 */
export const nml = 'application/vnd.enliven';

/**
 * Express by Infoseek
 */
export const xpr = 'application/vnd.is-xpr';

/**
 * eXtended Image File Format (XIFF)
 */
export const xif = 'image/vnd.xiff';

/**
 * Extensible Forms Description Language
 */
export const xfdl = 'application/vnd.xfdl';

/**
 * Extensible MultiModal Annotation
 */
export const emma = 'application/emma+xml';

/**
 * EZPix Secure Photo Album
 */
export const ez2 = 'application/vnd.ezpix-album';

/**
 * EZPix Secure Photo Album
 */
export const ez3 = 'application/vnd.ezpix-package';

/**
 * FAST Search & Transfer ASA
 */
export const fst = 'image/vnd.fst';

/**
 * FAST Search & Transfer ASA
 */
export const fvt = 'video/vnd.fvt';

/**
 * FastBid Sheet
 */
export const fbs = 'image/vnd.fastbidsheet';

/**
 * FCS Express Layout Link
 */
export const fe_launch = 'application/vnd.denovo.fcselayout-link';

/**
 * Flash Video
 */
export const f4v = 'video/x-f4v';

/**
 * Flash Video
 */
export const flv = 'video/x-flv';

/**
 * FlashPix
 */
export const fpx = 'image/vnd.fpx';

/**
 * FlashPix
 */
export const npx = 'image/vnd.net-fpx';

/**
 * FLEXSTOR
 */
export const flx = 'text/vnd.fmi.flexstor';

/**
 * FLI/FLC Animation Format
 */
export const fli = 'video/x-fli';

/**
 * FluxTime Clip
 */
export const ftc = 'application/vnd.fluxtime.clip';

/**
 * Forms Data Format
 */
export const fdf = 'application/vnd.fdf';

/**
 * Fortran Source File
 */
export const f = 'text/x-fortran';

/**
 * FrameMaker Interchange Format
 */
export const mif = 'application/vnd.mif';

/**
 * FrameMaker Normal Format
 */
export const fm = 'application/vnd.framemaker';

/**
 * FreeHand MX
 */
export const fh = 'image/x-freehand';

/**
 * Friendly Software Corporation
 */
export const fsc = 'application/vnd.fsc.weblaunch';

/**
 * Frogans Player
 */
export const fnc = 'application/vnd.frogans.fnc';

/**
 * Frogans Player
 */
export const ltf = 'application/vnd.frogans.ltf';

/**
 * Fujitsu - Xerox 2D CAD Data
 */
export const ddd = 'application/vnd.fujixerox.ddd';

/**
 * Fujitsu - Xerox DocuWorks
 */
export const xdw = 'application/vnd.fujixerox.docuworks';

/**
 * Fujitsu - Xerox DocuWorks Binder
 */
export const xbd = 'application/vnd.fujixerox.docuworks.binder';

/**
 * Fujitsu Oasys
 */
export const oas = 'application/vnd.fujitsu.oasys';

/**
 * Fujitsu Oasys
 */
export const oa2 = 'application/vnd.fujitsu.oasys2';

/**
 * Fujitsu Oasys
 */
export const oa3 = 'application/vnd.fujitsu.oasys3';

/**
 * Fujitsu Oasys
 */
export const fg5 = 'application/vnd.fujitsu.oasysgp';

/**
 * Fujitsu Oasys
 */
export const bh2 = 'application/vnd.fujitsu.oasysprs';

/**
 * FutureSplash Animator
 */
export const spl = 'application/x-futuresplash';

/**
 * FuzzySheet
 */
export const fzs = 'application/vnd.fuzzysheet';

/**
 * G3 Fax Image
 */
export const g3 = 'image/g3fax';

/**
 * GameMaker ActiveX
 */
export const gmx = 'application/vnd.gmx';

/**
 * Gen-Trix Studio
 */
export const gtw = 'model/vnd.gtw';

/**
 * Genomatix Tuxedo Framework
 */
export const txd = 'application/vnd.genomatix.tuxedo';

/**
 * GeoGebra
 */
export const ggb = 'application/vnd.geogebra.file';

/**
 * GeoGebra
 */
export const ggt = 'application/vnd.geogebra.tool';

/**
 * Geometric Description Language (GDL)
 */
export const gdl = 'model/vnd.gdl';

/**
 * GeoMetry Explorer
 */
export const gex = 'application/vnd.geometry-explorer';

/**
 * GEONExT and JSXGraph
 */
export const gxt = 'application/vnd.geonext';

/**
 * GeoplanW
 */
export const g2w = 'application/vnd.geoplan';

/**
 * GeospacW
 */
export const g3w = 'application/vnd.geospace';

/**
 * Ghostscript Font
 */
export const gsf = 'application/x-font-ghostscript';

/**
 * Glyph Bitmap Distribution Format
 */
export const bdf = 'application/x-font-bdf';

/**
 * GNU Tar Files
 */
export const gtar = 'application/x-gtar';

/**
 * GNU Texinfo Document
 */
export const texinfo = 'application/x-texinfo';

/**
 * Gnumeric
 */
export const gnumeric = 'application/x-gnumeric';

/**
 * Google Earth - KML
 */
export const kml = 'application/vnd.google-earth.kml+xml';

/**
 * Google Earth - Zipped KML
 */
export const kmz = 'application/vnd.google-earth.kmz';

/**
 * GrafEq
 */
export const gqf = 'application/vnd.grafeq';

/**
 * Graphics Interchange Format
 */
export const gif = 'image/gif';

/**
 * Graphviz
 */
export const gv = 'text/vnd.graphviz';

/**
 * Groove - Account
 */
export const gac = 'application/vnd.groove-account';

/**
 * Groove - Help
 */
export const ghf = 'application/vnd.groove-help';

/**
 * Groove - Identity Message
 */
export const gim = 'application/vnd.groove-identity-message';

/**
 * Groove - Injector
 */
export const grv = 'application/vnd.groove-injector';

/**
 * Groove - Tool Message
 */
export const gtm = 'application/vnd.groove-tool-message';

/**
 * Groove - Tool Template
 */
export const tpl = 'application/vnd.groove-tool-template';

/**
 * Groove - Vcard
 */
export const vcg = 'application/vnd.groove-vcard';

/**
 * H.261
 */
export const h261 = 'video/h261';

/**
 * H.263
 */
export const h263 = 'video/h263';

/**
 * H.264
 */
export const h264 = 'video/h264';

/**
 * Hewlett Packard Instant Delivery
 */
export const hpid = 'application/vnd.hp-hpid';

/**
 * Hewlett-Packard's WebPrintSmart
 */
export const hps = 'application/vnd.hp-hps';

/**
 * Hierarchical Data Format
 */
export const hdf = 'application/x-hdf';

/**
 * Hit'n'Mix
 */
export const rip = 'audio/vnd.rip';

/**
 * Homebanking Computer Interface (HBCI)
 */
export const hbci = 'application/vnd.hbci';

/**
 * HP Indigo Digital Press - Job Layout Languate
 */
export const jlt = 'application/vnd.hp-jlyt';

/**
 * HP Printer Command Language
 */
export const pcl = 'application/vnd.hp-pcl';

/**
 * HP-GL/2 and HP RTL
 */
export const hpgl = 'application/vnd.hp-hpgl';

/**
 * HV Script
 */
export const hvs = 'application/vnd.yamaha.hv-script';

/**
 * HV Voice Dictionary
 */
export const hvd = 'application/vnd.yamaha.hv-dic';

/**
 * HV Voice Parameter
 */
export const hvp = 'application/vnd.yamaha.hv-voice';

/**
 * Hydrostatix Master Suite
 */
export const sfd_hdstx = 'application/vnd.hydrostatix.sof-data';

/**
 * Hyperstudio
 */
export const stk = 'application/hyperstudio';

/**
 * Hypertext Application Language
 */
export const hal = 'application/vnd.hal+xml';

/**
 * HyperText Markup Language (HTML)
 */
export const html = 'text/html';

/**
 * IBM DB2 Rights Manager
 */
export const irm = 'application/vnd.ibm.rights-management';

/**
 * IBM Electronic Media Management System - Secure Container
 */
export const sc = 'application/vnd.ibm.secure-container';

/**
 * iCalendar
 */
export const ics = 'text/calendar';

/**
 * ICC profile
 */
export const icc = 'application/vnd.iccprofile';

/**
 * Icon Image
 */
export const ico = 'image/x-icon';

/**
 * igLoader
 */
export const igl = 'application/vnd.igloader';

/**
 * Image Exchange Format
 */
export const ief = 'image/ief';

/**
 * ImmerVision PURE Players
 */
export const ivp = 'application/vnd.immervision-ivp';

/**
 * ImmerVision PURE Players
 */
export const ivu = 'application/vnd.immervision-ivu';

/**
 * IMS Networks
 */
export const rif = 'application/reginfo+xml';

/**
 * In3D - 3DML
 */
export const spot = 'text/vnd.in3d.spot';

/**
 * Initial Graphics Exchange Specification (IGES)
 */
export const igs = 'model/iges';

/**
 * Interactive Geometry Software
 */
export const i2g = 'application/vnd.intergeo';

/**
 * Interactive Geometry Software Cinderella
 */
export const cdy = 'application/vnd.cinderella';

/**
 * Intercon FormNet
 */
export const xpw = 'application/vnd.intercon.formnet';

/**
 * International Society for Advancement of Cytometry
 */
export const fcs = 'application/vnd.isac.fcs';

/**
 * Internet Protocol Flow Information Export
 */
export const ipfix = 'application/ipfix';

/**
 * Internet Public Key Infrastructure - Certificate
 */
export const cer = 'application/pkix-cert';

/**
 * Internet Public Key Infrastructure - Certificate Management Protocole
 */
export const pki = 'application/pkixcmp';

/**
 * Internet Public Key Infrastructure - Certificate Revocation Lists
 */
export const crl = 'application/pkix-crl';

/**
 * Internet Public Key Infrastructure - Certification Path
 */
export const pkipath = 'application/pkix-pkipath';

/**
 * IOCOM Visimeet
 */
export const igm = 'application/vnd.insors.igm';

/**
 * IP Unplugged Roaming Client
 */
export const rcprofile = 'application/vnd.ipunplugged.rcprofile';

/**
 * iRepository / Lucidoc Editor
 */
export const irp = 'application/vnd.irepository.package+xml';

/**
 * J2ME App Descriptor
 */
export const jad = 'text/vnd.sun.j2me.app-descriptor';

/**
 * Java Archive
 */
export const jar = 'application/java-archive';

/**
 * Java Bytecode File
 */
export const _class = 'application/java-vm';

/**
 * Java Network Launching Protocol
 */
export const jnlp = 'application/x-java-jnlp-file';

/**
 * Java Serialized Object
 */
export const ser = 'application/java-serialized-object';

/**
 * Java Source File
 */
export const java = 'text/x-java-source,java';

/**
 * JavaScript
 */
export const js = 'application/javascript';

/**
 * JavaScript Object Notation (JSON)
 */
export const json = 'application/json';

/**
 * Joda Archive
 */
export const joda = 'application/vnd.joost.joda-archive';

/**
 * JPEG 2000 Compound Image File Format
 */
export const jpm = 'video/jpm';

/**
 * JPEG Image
 */
export const jpeg = 'image/jpeg';

/**
 * JPGVideo
 */
export const jpgv = 'video/jpeg';

/**
 * Kahootz
 */
export const ktz = 'application/vnd.kahootz';

/**
 * Karaoke on Chipnuts Chipsets
 */
export const mmd = 'application/vnd.chipnuts.karaoke-mmd';

/**
 * KDE KOffice Office Suite - Karbon
 */
export const karbon = 'application/vnd.kde.karbon';

/**
 * KDE KOffice Office Suite - KChart
 */
export const chrt = 'application/vnd.kde.kchart';

/**
 * KDE KOffice Office Suite - Kformula
 */
export const kfo = 'application/vnd.kde.kformula';

/**
 * KDE KOffice Office Suite - Kivio
 */
export const flw = 'application/vnd.kde.kivio';

/**
 * KDE KOffice Office Suite - Kontour
 */
export const kon = 'application/vnd.kde.kontour';

/**
 * KDE KOffice Office Suite - Kpresenter
 */
export const kpr = 'application/vnd.kde.kpresenter';

/**
 * KDE KOffice Office Suite - Kspread
 */
export const ksp = 'application/vnd.kde.kspread';

/**
 * KDE KOffice Office Suite - Kword
 */
export const kwd = 'application/vnd.kde.kword';

/**
 * Kenamea App
 */
export const htke = 'application/vnd.kenameaapp';

/**
 * Kidspiration
 */
export const kia = 'application/vnd.kidspiration';

/**
 * Kinar Applications
 */
export const kne = 'application/vnd.kinar';

/**
 * Kodak Storyshare
 */
export const sse = 'application/vnd.kodak-descriptor';

/**
 * Laser App Enterprise
 */
export const lasxml = 'application/vnd.las.las+xml';

/**
 * LaTeX
 */
export const latex = 'application/x-latex';

/**
 * Life Balance - Desktop Edition
 */
export const lbd = 'application/vnd.llamagraphics.life-balance.desktop';

/**
 * Life Balance - Exchange Format
 */
export const lbe = 'application/vnd.llamagraphics.life-balance.exchange+xml';

/**
 * Lightspeed Audio Lab
 */
export const jam = 'application/vnd.jam';

/**
 * Lotus 1-2-3
 */
export const _123 = 'application/vnd.lotus-1-2-3';

/**
 * Lotus Approach
 */
export const apr = 'application/vnd.lotus-approach';

/**
 * Lotus Freelance
 */
export const pre = 'application/vnd.lotus-freelance';

/**
 * Lotus Notes
 */
export const nsf = 'application/vnd.lotus-notes';

/**
 * Lotus Organizer
 */
export const org = 'application/vnd.lotus-organizer';

/**
 * Lotus Screencam
 */
export const scm = 'application/vnd.lotus-screencam';

/**
 * Lotus Wordpro
 */
export const lwp = 'application/vnd.lotus-wordpro';

/**
 * Lucent Voice
 */
export const lvp = 'audio/vnd.lucent.voice';

/**
 * M3U (Multimedia Playlist)
 */
export const m3u = 'audio/x-mpegurl';

/**
 * M4v
 */
export const m4v = 'video/x-m4v';

/**
 * Macintosh BinHex 4.0
 */
export const hqx = 'application/mac-binhex40';

/**
 * MacPorts Port System
 */
export const portpkg = 'application/vnd.macports.portpkg';

/**
 * MapGuide DBXML
 */
export const mgp = 'application/vnd.osgeo.mapguide.package';

/**
 * MARC Formats
 */
export const mrc = 'application/marc';

/**
 * MARC21 XML Schema
 */
export const mrcx = 'application/marcxml+xml';

/**
 * Material Exchange Format
 */
export const mxf = 'application/mxf';

/**
 * Mathematica Notebook Player
 */
export const nbp = 'application/vnd.wolfram.player';

/**
 * Mathematica Notebooks
 */
export const ma = 'application/mathematica';

/**
 * Mathematical Markup Language
 */
export const mathml = 'application/mathml+xml';

/**
 * Mbox database files
 */
export const mbox = 'application/mbox';

/**
 * MedCalc
 */
export const mc1 = 'application/vnd.medcalcdata';

/**
 * Media Server Control Markup Language
 */
export const mscml = 'application/mediaservercontrol+xml';

/**
 * MediaRemote
 */
export const cdkey = 'application/vnd.mediastation.cdkey';

/**
 * Medical Waveform Encoding Format
 */
export const mwf = 'application/vnd.mfer';

/**
 * Melody Format for Mobile Platform
 */
export const mfm = 'application/vnd.mfmp';

/**
 * Mesh Data Type
 */
export const msh = 'model/mesh';

/**
 * Metadata Authority Description Schema
 */
export const mads = 'application/mads+xml';

/**
 * Metadata Encoding and Transmission Standard
 */
export const mets = 'application/mets+xml';

/**
 * Metadata Object Description Schema
 */
export const mods = 'application/mods+xml';

/**
 * Metalink
 */
export const meta4 = 'application/metalink4+xml';

/**
 * Micosoft PowerPoint - Macro-Enabled Template File
 */
export const potm = 'application/vnd.ms-powerpoint.template.macroenabled.12';

/**
 * Micosoft Word - Macro-Enabled Document
 */
export const docm = 'application/vnd.ms-word.document.macroenabled.12';

/**
 * Micosoft Word - Macro-Enabled Template
 */
export const dotm = 'application/vnd.ms-word.template.macroenabled.12';

/**
 * Micro CADAM Helix D&D
 */
export const mcd = 'application/vnd.mcd';

/**
 * Micrografx
 */
export const flo = 'application/vnd.micrografx.flo';

/**
 * Micrografx iGrafx Professional
 */
export const igx = 'application/vnd.micrografx.igx';

/**
 * MICROSEC e-Szign
 */
export const es3 = 'application/vnd.eszigno3+xml';

/**
 * Microsoft Access
 */
export const mdb = 'application/x-msaccess';

/**
 * Microsoft Advanced Systems Format (ASF)
 */
export const asf = 'video/x-ms-asf';

/**
 * Microsoft Application
 */
export const exe = 'application/x-msdownload';

/**
 * Microsoft Artgalry
 */
export const cil = 'application/vnd.ms-artgalry';

/**
 * Microsoft Cabinet File
 */
export const cab = 'application/vnd.ms-cab-compressed';

/**
 * Microsoft Class Server
 */
export const ims = 'application/vnd.ms-ims';

/**
 * Microsoft ClickOnce
 */
export const application = 'application/x-ms-application';

/**
 * Microsoft Clipboard Clip
 */
export const clp = 'application/x-msclip';

/**
 * Microsoft Document Imaging Format
 */
export const mdi = 'image/vnd.ms-modi';

/**
 * Microsoft Embedded OpenType
 */
export const eot = 'application/vnd.ms-fontobject';

/**
 * Microsoft Excel
 */
export const xls = 'application/vnd.ms-excel';

/**
 * Microsoft Excel - Add-In File
 */
export const xlam = 'application/vnd.ms-excel.addin.macroenabled.12';

/**
 * Microsoft Excel - Binary Workbook
 */
export const xlsb = 'application/vnd.ms-excel.sheet.binary.macroenabled.12';

/**
 * Microsoft Excel - Macro-Enabled Template File
 */
export const xltm = 'application/vnd.ms-excel.template.macroenabled.12';

/**
 * Microsoft Excel - Macro-Enabled Workbook
 */
export const xlsm = 'application/vnd.ms-excel.sheet.macroenabled.12';

/**
 * Microsoft Html Help File
 */
export const chm = 'application/vnd.ms-htmlhelp';

/**
 * Microsoft Information Card
 */
export const crd = 'application/x-mscardfile';

/**
 * Microsoft Learning Resource Module
 */
export const lrm = 'application/vnd.ms-lrm';

/**
 * Microsoft MediaView
 */
export const mvb = 'application/x-msmediaview';

/**
 * Microsoft Money
 */
export const mny = 'application/x-msmoney';

/**
 * Microsoft Office - OOXML - Presentation
 */
export const pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';

/**
 * Microsoft Office - OOXML - Presentation (Slide)
 */
export const sldx = 'application/vnd.openxmlformats-officedocument.presentationml.slide';

/**
 * Microsoft Office - OOXML - Presentation (Slideshow)
 */
export const ppsx = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow';

/**
 * Microsoft Office - OOXML - Presentation Template
 */
export const potx = 'application/vnd.openxmlformats-officedocument.presentationml.template';

/**
 * Microsoft Office - OOXML - Spreadsheet
 */
export const xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Microsoft Office - OOXML - Spreadsheet Teplate
 */
export const xltx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.template';

/**
 * Microsoft Office - OOXML - Word Document
 */
export const docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

/**
 * Microsoft Office - OOXML - Word Document Template
 */
export const dotx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template';

/**
 * Microsoft Office Binder
 */
export const obd = 'application/x-msbinder';

/**
 * Microsoft Office System Release Theme
 */
export const thmx = 'application/vnd.ms-officetheme';

/**
 * Microsoft OneNote
 */
export const onetoc = 'application/onenote';

/**
 * Microsoft PlayReady Ecosystem
 */
export const pya = 'audio/vnd.ms-playready.media.pya';

/**
 * Microsoft PlayReady Ecosystem Video
 */
export const pyv = 'video/vnd.ms-playready.media.pyv';

/**
 * Microsoft PowerPoint
 */
export const ppt = 'application/vnd.ms-powerpoint';

/**
 * Microsoft PowerPoint - Add-in file
 */
export const ppam = 'application/vnd.ms-powerpoint.addin.macroenabled.12';

/**
 * Microsoft PowerPoint - Macro-Enabled Open XML Slide
 */
export const sldm = 'application/vnd.ms-powerpoint.slide.macroenabled.12';

/**
 * Microsoft PowerPoint - Macro-Enabled Presentation File
 */
export const pptm = 'application/vnd.ms-powerpoint.presentation.macroenabled.12';

/**
 * Microsoft PowerPoint - Macro-Enabled Slide Show File
 */
export const ppsm = 'application/vnd.ms-powerpoint.slideshow.macroenabled.12';

/**
 * Microsoft Project
 */
export const mpp = 'application/vnd.ms-project';

/**
 * Microsoft Publisher
 */
export const pub = 'application/x-mspublisher';

/**
 * Microsoft Schedule+
 */
export const scd = 'application/x-msschedule';

/**
 * Microsoft Silverlight
 */
export const xap = 'application/x-silverlight-app';

/**
 * Microsoft Trust UI Provider - Certificate Trust Link
 */
export const stl = 'application/vnd.ms-pki.stl';

/**
 * Microsoft Trust UI Provider - Security Catalog
 */
export const cat = 'application/vnd.ms-pki.seccat';

/**
 * Microsoft Visio
 */
export const vsd = 'application/vnd.visio';

/**
 * Microsoft Windows Media
 */
export const wm = 'video/x-ms-wm';

/**
 * Microsoft Windows Media Audio
 */
export const wma = 'audio/x-ms-wma';

/**
 * Microsoft Windows Media Audio Redirector
 */
export const wax = 'audio/x-ms-wax';

/**
 * Microsoft Windows Media Audio/Video Playlist
 */
export const wmx = 'video/x-ms-wmx';

/**
 * Microsoft Windows Media Player Download Package
 */
export const wmd = 'application/x-ms-wmd';

/**
 * Microsoft Windows Media Player Playlist
 */
export const wpl = 'application/vnd.ms-wpl';

/**
 * Microsoft Windows Media Player Skin Package
 */
export const wmz = 'application/x-ms-wmz';

/**
 * Microsoft Windows Media Video
 */
export const wmv = 'video/x-ms-wmv';

/**
 * Microsoft Windows Media Video Playlist
 */
export const wvx = 'video/x-ms-wvx';

/**
 * Microsoft Windows Metafile
 */
export const wmf = 'application/x-msmetafile';

/**
 * Microsoft Windows Terminal Services
 */
export const trm = 'application/x-msterminal';

/**
 * Microsoft Word
 */
export const doc = 'application/msword';

/**
 * Microsoft Wordpad
 */
export const wri = 'application/x-mswrite';

/**
 * Microsoft Works
 */
export const wps = 'application/vnd.ms-works';

/**
 * Microsoft XAML Browser Application
 */
export const xbap = 'application/x-ms-xbap';

/**
 * Microsoft XML Paper Specification
 */
export const xps = 'application/vnd.ms-xpsdocument';

/**
 * MIDI - Musical Instrument Digital Interface
 */
export const mid = 'audio/midi';

/**
 * MiniPay
 */
export const mpy = 'application/vnd.ibm.minipay';

/**
 * MO:DCA-P
 */
export const afp = 'application/vnd.ibm.modcap';

/**
 * Mobile Information Device Profile
 */
export const rms = 'application/vnd.jcp.javame.midlet-rms';

/**
 * MobileTV
 */
export const tmo = 'application/vnd.tmobile-livetv';

/**
 * Mobipocket
 */
export const prc = 'application/x-mobipocket-ebook';

/**
 * Mobius Management Systems - Basket file
 */
export const mbk = 'application/vnd.mobius.mbk';

/**
 * Mobius Management Systems - Distribution Database
 */
export const dis = 'application/vnd.mobius.dis';

/**
 * Mobius Management Systems - Policy Definition Language File
 */
export const plc = 'application/vnd.mobius.plc';

/**
 * Mobius Management Systems - Query File
 */
export const mqy = 'application/vnd.mobius.mqy';

/**
 * Mobius Management Systems - Script Language
 */
export const msl = 'application/vnd.mobius.msl';

/**
 * Mobius Management Systems - Topic Index File
 */
export const txf = 'application/vnd.mobius.txf';

/**
 * Mobius Management Systems - UniversalArchive
 */
export const daf = 'application/vnd.mobius.daf';

/**
 * mod_fly / fly.cgi
 */
export const fly = 'text/vnd.fly';

/**
 * Mophun Certificate
 */
export const mpc = 'application/vnd.mophun.certificate';

/**
 * Mophun VM
 */
export const mpn = 'application/vnd.mophun.application';

/**
 * Motion JPEG 2000
 */
export const mj2 = 'video/mj2';

/**
 * MPEG Audio
 */
export const mpga = 'audio/mpeg';

/**
 * MPEG Url
 */
export const mxu = 'video/vnd.mpegurl';

/**
 * MPEG Video
 */
export const mpeg = 'video/mpeg';

/**
 * MPEG-21
 */
export const m21 = 'application/mp21';

/**
 * MPEG-4 Audio
 */
export const mp4a = 'audio/mp4';

/**
 * MPEG-4 Video
 */
export const _mp4 = 'video/mp4';

/**
 * MPEG4
 */
export const mp4 = 'application/mp4';

/**
 * Multimedia Playlist Unicode
 */
export const m3u8 = 'application/vnd.apple.mpegurl';

/**
 * MUsical Score Interpreted Code Invented for the ASCII designation of Notation
 */
export const mus = 'application/vnd.musician';

/**
 * Muvee Automatic Video Editing
 */
export const msty = 'application/vnd.muvee.style';

/**
 * MXML
 */
export const mxml = 'application/xv+xml';

/**
 * N-Gage Game Data
 */
export const ngdat = 'application/vnd.nokia.n-gage.data';

/**
 * N-Gage Game Installer
 */
export const n_gage = 'application/vnd.nokia.n-gage.symbian.install';

/**
 * Navigation Control file for XML (for ePub)
 */
export const ncx = 'application/x-dtbncx+xml';

/**
 * Network Common Data Form (NetCDF)
 */
export const nc = 'application/x-netcdf';

/**
 * neuroLanguage
 */
export const nlu = 'application/vnd.neurolanguage.nlu';

/**
 * New Moon Liftoff/DNA
 */
export const dna = 'application/vnd.dna';

/**
 * NobleNet Directory
 */
export const nnd = 'application/vnd.noblenet-directory';

/**
 * NobleNet Sealer
 */
export const nns = 'application/vnd.noblenet-sealer';

/**
 * NobleNet Web
 */
export const nnw = 'application/vnd.noblenet-web';

/**
 * Nokia Radio Application - Preset
 */
export const rpst = 'application/vnd.nokia.radio-preset';

/**
 * Nokia Radio Application - Preset
 */
export const rpss = 'application/vnd.nokia.radio-presets';

/**
 * Notation3
 */
export const n3 = 'text/n3';

/**
 * Novadigm's RADIA and EDM products
 */
export const edm = 'application/vnd.novadigm.edm';

/**
 * Novadigm's RADIA and EDM products
 */
export const edx = 'application/vnd.novadigm.edx';

/**
 * Novadigm's RADIA and EDM products
 */
export const ext = 'application/vnd.novadigm.ext';

/**
 * NpGraphIt
 */
export const gph = 'application/vnd.flographit';

/**
 * Nuera ECELP 4800
 */
export const ecelp4800 = 'audio/vnd.nuera.ecelp4800';

/**
 * Nuera ECELP 7470
 */
export const ecelp7470 = 'audio/vnd.nuera.ecelp7470';

/**
 * Nuera ECELP 9600
 */
export const ecelp9600 = 'audio/vnd.nuera.ecelp9600';

/**
 * Office Document Architecture
 */
export const oda = 'application/oda';

/**
 * Ogg
 */
export const ogx = 'application/ogg';

/**
 * Ogg Audio
 */
export const oga = 'audio/ogg';

/**
 * Ogg Video
 */
export const ogv = 'video/ogg';

/**
 * OMA Download Agents
 */
export const dd2 = 'application/vnd.oma.dd2+xml';

/**
 * Open Document Text Web
 */
export const oth = 'application/vnd.oasis.opendocument.text-web';

/**
 * Open eBook Publication Structure
 */
export const opf = 'application/oebps-package+xml';

/**
 * Open Financial Exchange
 */
export const qbo = 'application/vnd.intu.qbo';

/**
 * Open Office Extension
 */
export const oxt = 'application/vnd.openofficeorg.extension';

/**
 * Open Score Format
 */
export const osf = 'application/vnd.yamaha.openscoreformat';

/**
 * Open Web Media Project - Audio
 */
export const weba = 'audio/webm';

/**
 * Open Web Media Project - Video
 */
export const webm = 'video/webm';

/**
 * OpenDocument Chart
 */
export const odc = 'application/vnd.oasis.opendocument.chart';

/**
 * OpenDocument Chart Template
 */
export const otc = 'application/vnd.oasis.opendocument.chart-template';

/**
 * OpenDocument Database
 */
export const odb = 'application/vnd.oasis.opendocument.database';

/**
 * OpenDocument Formula
 */
export const odf = 'application/vnd.oasis.opendocument.formula';

/**
 * OpenDocument Formula Template
 */
export const odft = 'application/vnd.oasis.opendocument.formula-template';

/**
 * OpenDocument Graphics
 */
export const odg = 'application/vnd.oasis.opendocument.graphics';

/**
 * OpenDocument Graphics Template
 */
export const otg = 'application/vnd.oasis.opendocument.graphics-template';

/**
 * OpenDocument Image
 */
export const odi = 'application/vnd.oasis.opendocument.image';

/**
 * OpenDocument Image Template
 */
export const oti = 'application/vnd.oasis.opendocument.image-template';

/**
 * OpenDocument Presentation
 */
export const odp = 'application/vnd.oasis.opendocument.presentation';

/**
 * OpenDocument Presentation Template
 */
export const otp = 'application/vnd.oasis.opendocument.presentation-template';

/**
 * OpenDocument Spreadsheet
 */
export const ods = 'application/vnd.oasis.opendocument.spreadsheet';

/**
 * OpenDocument Spreadsheet Template
 */
export const ots = 'application/vnd.oasis.opendocument.spreadsheet-template';

/**
 * OpenDocument Text
 */
export const odt = 'application/vnd.oasis.opendocument.text';

/**
 * OpenDocument Text Master
 */
export const odm = 'application/vnd.oasis.opendocument.text-master';

/**
 * OpenDocument Text Template
 */
export const ott = 'application/vnd.oasis.opendocument.text-template';

/**
 * OpenGL Textures (KTX)
 */
export const ktx = 'image/ktx';

/**
 * OpenOffice - Calc (Spreadsheet)
 */
export const sxc = 'application/vnd.sun.xml.calc';

/**
 * OpenOffice - Calc Template (Spreadsheet)
 */
export const stc = 'application/vnd.sun.xml.calc.template';

/**
 * OpenOffice - Draw (Graphics)
 */
export const sxd = 'application/vnd.sun.xml.draw';

/**
 * OpenOffice - Draw Template (Graphics)
 */
export const std = 'application/vnd.sun.xml.draw.template';

/**
 * OpenOffice - Impress (Presentation)
 */
export const sxi = 'application/vnd.sun.xml.impress';

/**
 * OpenOffice - Impress Template (Presentation)
 */
export const sti = 'application/vnd.sun.xml.impress.template';

/**
 * OpenOffice - Math (Formula)
 */
export const sxm = 'application/vnd.sun.xml.math';

/**
 * OpenOffice - Writer (Text - HTML)
 */
export const sxw = 'application/vnd.sun.xml.writer';

/**
 * OpenOffice - Writer (Text - HTML)
 */
export const sxg = 'application/vnd.sun.xml.writer.global';

/**
 * OpenOffice - Writer Template (Text - HTML)
 */
export const stw = 'application/vnd.sun.xml.writer.template';

/**
 * OpenType Font File
 */
export const otf = 'application/x-font-otf';

/**
 * OSFPVG
 */
export const osfpvg = 'application/vnd.yamaha.openscoreformat.osfpvg+xml';

/**
 * OSGi Deployment Package
 */
export const dp = 'application/vnd.osgi.dp';

/**
 * PalmOS Data
 */
export const pdb = 'application/vnd.palm';

/**
 * Pascal Source File
 */
export const p = 'text/x-pascal';

/**
 * PawaaFILE
 */
export const paw = 'application/vnd.pawaafile';

/**
 * PCL 6 Enhanced (Formely PCL XL)
 */
export const pclxl = 'application/vnd.hp-pclxl';

/**
 * Pcsel eFIF File
 */
export const efif = 'application/vnd.picsel';

/**
 * PCX Image
 */
export const pcx = 'image/x-pcx';

/**
 * Photoshop Document
 */
export const psd = 'image/vnd.adobe.photoshop';

/**
 * PICSRules
 */
export const prf = 'application/pics-rules';

/**
 * PICT Image
 */
export const pic = 'image/x-pict';

/**
 * pIRCh
 */
export const chat = 'application/x-chat';

/**
 * PKCS #10 - Certification Request Standard
 */
export const p10 = 'application/pkcs10';

/**
 * PKCS #12 - Personal Information Exchange Syntax Standard
 */
export const p12 = 'application/x-pkcs12';

/**
 * PKCS #7 - Cryptographic Message Syntax Standard
 */
export const p7m = 'application/pkcs7-mime';

/**
 * PKCS #7 - Cryptographic Message Syntax Standard
 */
export const p7s = 'application/pkcs7-signature';

/**
 * PKCS #7 - Cryptographic Message Syntax Standard (Certificate Request Response)
 */
export const p7r = 'application/x-pkcs7-certreqresp';

/**
 * PKCS #7 - Cryptographic Message Syntax Standard (Certificates)
 */
export const p7b = 'application/x-pkcs7-certificates';

/**
 * PKCS #8 - Private-Key Information Syntax Standard
 */
export const p8 = 'application/pkcs8';

/**
 * PocketLearn Viewers
 */
export const plf = 'application/vnd.pocketlearn';

/**
 * Portable Anymap Image
 */
export const pnm = 'image/x-portable-anymap';

/**
 * Portable Bitmap Format
 */
export const pbm = 'image/x-portable-bitmap';

/**
 * Portable Compiled Format
 */
export const pcf = 'application/x-font-pcf';

/**
 * Portable Font Resource
 */
export const pfr = 'application/font-tdpfr';

/**
 * Portable Game Notation (Chess Games)
 */
export const pgn = 'application/x-chess-pgn';

/**
 * Portable Graymap Format
 */
export const pgm = 'image/x-portable-graymap';

/**
 * Portable Network Graphics (PNG)
 */
export const png = 'image/png';

/**
 * Portable Pixmap Format
 */
export const ppm = 'image/x-portable-pixmap';

/**
 * Portable Symmetric Key Container
 */
export const pskcxml = 'application/pskc+xml';

/**
 * PosML
 */
export const pml = 'application/vnd.ctc-posml';

/**
 * PostScript
 */
export const ai = 'application/postscript';

/**
 * PostScript Fonts
 */
export const pfa = 'application/x-font-type1';

/**
 * PowerBuilder
 */
export const pbd = 'application/vnd.powerbuilder6';

/**
 * Pretty Good Privacy
 */
export const _pgp = 'application/pgp-encrypted';

/**
 * Pretty Good Privacy - Signature
 */
export const pgp = 'application/pgp-signature';

/**
 * Preview Systems ZipLock/VBox
 */
export const box = 'application/vnd.previewsystems.box';

/**
 * Princeton Video Image
 */
export const ptid = 'application/vnd.pvi.ptid1';

/**
 * Pronunciation Lexicon Specification
 */
export const pls = 'application/pls+xml';

/**
 * Proprietary P&G Standard Reporting System
 */
export const str = 'application/vnd.pg.format';

/**
 * Proprietary P&G Standard Reporting System
 */
export const ei6 = 'application/vnd.pg.osasli';

/**
 * PRS Lines Tag
 */
export const dsc = 'text/prs.lines.tag';

/**
 * PSF Fonts
 */
export const psf = 'application/x-font-linux-psf';

/**
 * PubliShare Objects
 */
export const qps = 'application/vnd.publishare-delta-tree';

/**
 * Qualcomm's Plaza Mobile Internet
 */
export const wg = 'application/vnd.pmi.widget';

/**
 * QuarkXpress
 */
export const qxd = 'application/vnd.quark.quarkxpress';

/**
 * QUASS Stream Player
 */
export const esf = 'application/vnd.epson.esf';

/**
 * QUASS Stream Player
 */
export const msf = 'application/vnd.epson.msf';

/**
 * QUASS Stream Player
 */
export const ssf = 'application/vnd.epson.ssf';

/**
 * QuickAnime Player
 */
export const qam = 'application/vnd.epson.quickanime';

/**
 * Quicken
 */
export const qfx = 'application/vnd.intu.qfx';

/**
 * Quicktime Video
 */
export const qt = 'video/quicktime';

/**
 * RAR Archive
 */
export const rar = 'application/x-rar-compressed';

/**
 * Real Audio Sound
 */
export const ram = 'audio/x-pn-realaudio';

/**
 * Real Audio Sound
 */
export const rmp = 'audio/x-pn-realaudio-plugin';

/**
 * Really Simple Discovery
 */
export const rsd = 'application/rsd+xml';

/**
 * RealMedia
 */
export const rm = 'application/vnd.rn-realmedia';

/**
 * Recordare Applications
 */
export const mxl = 'application/vnd.recordare.musicxml';

/**
 * Recordare Applications
 */
export const musicxml = 'application/vnd.recordare.musicxml+xml';

/**
 * Relax NG Compact Syntax
 */
export const rnc = 'application/relax-ng-compact-syntax';

/**
 * RemoteDocs R-Viewer
 */
export const rdz = 'application/vnd.data-vision.rdz';

/**
 * Resource Description Framework
 */
export const rdf = 'application/rdf+xml';

/**
 * RetroPlatform Player
 */
export const rp9 = 'application/vnd.cloanto.rp9';

/**
 * RhymBox
 */
export const jisp = 'application/vnd.jisp';

/**
 * Rich Text Format
 */
export const rtf = 'application/rtf';

/**
 * Rich Text Format (RTF)
 */
export const rtx = 'text/richtext';

/**
 * ROUTE 66 Location Based Services
 */
export const link66 = 'application/vnd.route66.link66+xml';

/**
 * RSS - Really Simple Syndication
 */
export const rss = 'application/rss+xml';

/**
 * S Hexdump Format
 */
export const shf = 'application/shf+xml';

/**
 * SailingTracker
 */
export const st = 'application/vnd.sailingtracker.track';

/**
 * Scalable Vector Graphics (SVG)
 */
export const svg = 'image/svg+xml';

/**
 * ScheduleUs
 */
export const sus = 'application/vnd.sus-calendar';

/**
 * Search/Retrieve via URL Response Format
 */
export const sru = 'application/sru+xml';

/**
 * Secure Electronic Transaction - Payment
 */
export const setpay = 'application/set-payment-initiation';

/**
 * Secure Electronic Transaction - Registration
 */
export const setreg = 'application/set-registration-initiation';

/**
 * Secured eMail
 */
export const sema = 'application/vnd.sema';

/**
 * Secured eMail
 */
export const semd = 'application/vnd.semd';

/**
 * Secured eMail
 */
export const semf = 'application/vnd.semf';

/**
 * SeeMail
 */
export const see = 'application/vnd.seemail';

/**
 * Server Normal Format
 */
export const snf = 'application/x-font-snf';

/**
 * Server-Based Certificate Validation Protocol - Validation Policies - Request
 */
export const spq = 'application/scvp-vp-request';

/**
 * Server-Based Certificate Validation Protocol - Validation Policies - Response
 */
export const spp = 'application/scvp-vp-response';

/**
 * Server-Based Certificate Validation Protocol - Validation Request
 */
export const scq = 'application/scvp-cv-request';

/**
 * Server-Based Certificate Validation Protocol - Validation Response
 */
export const scs = 'application/scvp-cv-response';

/**
 * Session Description Protocol
 */
export const sdp = 'application/sdp';

/**
 * Setext
 */
export const etx = 'text/x-setext';

/**
 * SGI Movie
 */
export const movie = 'video/x-sgi-movie';

/**
 * Shana Informed Filler
 */
export const ifm = 'application/vnd.shana.informed.formdata';

/**
 * Shana Informed Filler
 */
export const itp = 'application/vnd.shana.informed.formtemplate';

/**
 * Shana Informed Filler
 */
export const iif = 'application/vnd.shana.informed.interchange';

/**
 * Shana Informed Filler
 */
export const ipk = 'application/vnd.shana.informed.package';

/**
 * Sharing Transaction Fraud Data
 */
export const tfi = 'application/thraud+xml';

/**
 * Shell Archive
 */
export const shar = 'application/x-shar';

/**
 * Silicon Graphics RGB Bitmap
 */
export const rgb = 'image/x-rgb';

/**
 * SimpleAnimeLite Player
 */
export const slt = 'application/vnd.epson.salt';

/**
 * Simply Accounting
 */
export const aso = 'application/vnd.accpac.simply.aso';

/**
 * Simply Accounting - Data Import
 */
export const imp = 'application/vnd.accpac.simply.imp';

/**
 * SimTech MindMapper
 */
export const twd = 'application/vnd.simtech-mindmapper';

/**
 * Sixth Floor Media - CommonSpace
 */
export const csp = 'application/vnd.commonspace';

/**
 * SMAF Audio
 */
export const saf = 'application/vnd.yamaha.smaf-audio';

/**
 * SMAF File
 */
export const mmf = 'application/vnd.smaf';

/**
 * SMAF Phrase
 */
export const spf = 'application/vnd.yamaha.smaf-phrase';

/**
 * SMART Technologies Apps
 */
export const teacher = 'application/vnd.smart.teacher';

/**
 * SourceView Document
 */
export const svd = 'application/vnd.svd';

/**
 * SPARQL - Query
 */
export const rq = 'application/sparql-query';

/**
 * SPARQL - Results
 */
export const srx = 'application/sparql-results+xml';

/**
 * Speech Recognition Grammar Specification
 */
export const gram = 'application/srgs';

/**
 * Speech Recognition Grammar Specification - XML
 */
export const grxml = 'application/srgs+xml';

/**
 * Speech Synthesis Markup Language
 */
export const ssml = 'application/ssml+xml';

/**
 * SSEYO Koan Play File
 */
export const skp = 'application/vnd.koan';

/**
 * Standard Generalized Markup Language (SGML)
 */
export const sgml = 'text/sgml';

/**
 * StarOffice - Calc
 */
export const sdc = 'application/vnd.stardivision.calc';

/**
 * StarOffice - Impress
 */
export const sdd = 'application/vnd.stardivision.impress';

/**
 * StarOffice - Writer
 */
export const sdw = 'application/vnd.stardivision.writer';

/**
 * StepMania
 */
export const sm = 'application/vnd.stepmania.stepchart';

/**
 * Stuffit Archive
 */
export const sit = 'application/x-stuffit';

/**
 * Stuffit Archive
 */
export const sitx = 'application/x-stuffitx';

/**
 * SudokuMagic
 */
export const sdkm = 'application/vnd.solent.sdkm+xml';

/**
 * Sugar Linux Application Bundle
 */
export const xo = 'application/vnd.olpc-sugar';

/**
 * Sun Audio - Au file format
 */
export const au = 'audio/basic';

/**
 * SundaHus WQ
 */
export const wqd = 'application/vnd.wqd';

/**
 * Symbian Install Package
 */
export const sis = 'application/vnd.symbian.install';

/**
 * Synchronized Multimedia Integration Language
 */
export const smi = 'application/smil+xml';

/**
 * SyncML
 */
export const xsm = 'application/vnd.syncml+xml';

/**
 * SyncML - Device Management
 */
export const bdm = 'application/vnd.syncml.dm+wbxml';

/**
 * SyncML - Device Management
 */
export const xdm = 'application/vnd.syncml.dm+xml';

/**
 * System V Release 4 CPIO Archive
 */
export const sv4cpio = 'application/x-sv4cpio';

/**
 * System V Release 4 CPIO Checksum Data
 */
export const sv4crc = 'application/x-sv4crc';

/**
 * Systems Biology Markup Language
 */
export const sbml = 'application/sbml+xml';

/**
 * Tab Seperated Values
 */
export const tsv = 'text/tab-separated-values';

/**
 * Tagged Image File Format
 */
export const tiff = 'image/tiff';

/**
 * Tao Intent
 */
export const tao = 'application/vnd.tao.intent-module-archive';

/**
 * Tar File (Tape Archive)
 */
export const tar = 'application/x-tar';

/**
 * Tcl Script
 */
export const tcl = 'application/x-tcl';

/**
 * TeX
 */
export const tex = 'application/x-tex';

/**
 * TeX Font Metric
 */
export const tfm = 'application/x-tex-tfm';

/**
 * Text Encoding and Interchange
 */
export const tei = 'application/tei+xml';

/**
 * Text File
 */
export const txt = 'text/plain';

/**
 * TIBCO Spotfire
 */
export const dxp = 'application/vnd.spotfire.dxp';

/**
 * TIBCO Spotfire
 */
export const sfs = 'application/vnd.spotfire.sfs';

/**
 * Time Stamped Data Envelope
 */
export const tsd = 'application/timestamped-data';

/**
 * TRI Systems Config
 */
export const tpt = 'application/vnd.trid.tpt';

/**
 * Triscape Map Explorer
 */
export const mxs = 'application/vnd.triscape.mxs';

/**
 * troff
 */
export const t = 'text/troff';

/**
 * True BASIC
 */
export const tra = 'application/vnd.trueapp';

/**
 * TrueType Font
 */
export const ttf = 'application/x-font-ttf';

/**
 * Turtle (Terse RDF Triple Language)
 */
export const ttl = 'text/turtle';

/**
 * UMAJIN
 */
export const umj = 'application/vnd.umajin';

/**
 * Unique Object Markup Language
 */
export const uoml = 'application/vnd.uoml+xml';

/**
 * Unity 3d
 */
export const unityweb = 'application/vnd.unity';

/**
 * Universal Forms Description Language
 */
export const ufd = 'application/vnd.ufdl';

/**
 * URI Resolution Services
 */
export const uri = 'text/uri-list';

/**
 * User Interface Quartz - Theme (Symbian)
 */
export const utz = 'application/vnd.uiq.theme';

/**
 * Ustar (Uniform Standard Tape Archive)
 */
export const ustar = 'application/x-ustar';

/**
 * UUEncode
 */
export const uu = 'text/x-uuencode';

/**
 * vCalendar
 */
export const vcs = 'text/x-vcalendar';

/**
 * vCard
 */
export const vcf = 'text/x-vcard';

/**
 * Video CD
 */
export const vcd = 'application/x-cdlink';

/**
 * Viewport+
 */
export const vsf = 'application/vnd.vsf';

/**
 * Virtual Reality Modeling Language
 */
export const wrl = 'model/vrml';

/**
 * VirtualCatalog
 */
export const vcx = 'application/vnd.vcx';

/**
 * Virtue MTS
 */
export const mts = 'model/vnd.mts';

/**
 * Virtue VTU
 */
export const vtu = 'model/vnd.vtu';

/**
 * Visionary
 */
export const vis = 'application/vnd.visionary';

/**
 * Vivo
 */
export const viv = 'video/vnd.vivo';

/**
 * Voice Browser Call Control
 */
export const ccxml = 'application/ccxml+xml,';

/**
 * VoiceXML
 */
export const vxml = 'application/voicexml+xml';

/**
 * WAIS Source
 */
export const src = 'application/x-wais-source';

/**
 * WAP Binary XML (WBXML)
 */
export const wbxml = 'application/vnd.wap.wbxml';

/**
 * WAP Bitamp (WBMP)
 */
export const wbmp = 'image/vnd.wap.wbmp';

/**
 * Waveform Audio File Format (WAV)
 */
export const wav = 'audio/x-wav';

/**
 * Web Distributed Authoring and Versioning
 */
export const davmount = 'application/davmount+xml';

/**
 * Web Open Font Format
 */
export const woff = 'application/x-font-woff';

/**
 * Web Services Policy
 */
export const wspolicy = 'application/wspolicy+xml';

/**
 * WebP Image
 */
export const webp = 'image/webp';

/**
 * WebTurbo
 */
export const wtb = 'application/vnd.webturbo';

/**
 * Widget Packaging and XML Configuration
 */
export const wgt = 'application/widget';

/**
 * WinHelp
 */
export const hlp = 'application/winhlp';

/**
 * Wireless Markup Language (WML)
 */
export const wml = 'text/vnd.wap.wml';

/**
 * Wireless Markup Language Script (WMLScript)
 */
export const wmls = 'text/vnd.wap.wmlscript';

/**
 * WMLScript
 */
export const wmlsc = 'application/vnd.wap.wmlscriptc';

/**
 * Wordperfect
 */
export const wpd = 'application/vnd.wordperfect';

/**
 * Worldtalk
 */
export const stf = 'application/vnd.wt.stf';

/**
 * WSDL - Web Services Description Language
 */
export const wsdl = 'application/wsdl+xml';

/**
 * X BitMap
 */
export const xbm = 'image/x-xbitmap';

/**
 * X PixMap
 */
export const xpm = 'image/x-xpixmap';

/**
 * X Window Dump
 */
export const xwd = 'image/x-xwindowdump';

/**
 * X.509 Certificate
 */
export const der = 'application/x-x509-ca-cert';

/**
 * Xfig
 */
export const fig = 'application/x-xfig';

/**
 * XHTML - The Extensible HyperText Markup Language
 */
export const xhtml = 'application/xhtml+xml';

/**
 * XML - Extensible Markup Language
 */
export const xml = 'application/xml';

/**
 * XML Configuration Access Protocol - XCAP Diff
 */
export const xdf = 'application/xcap-diff+xml';

/**
 * XML Encryption Syntax and Processing
 */
export const xenc = 'application/xenc+xml';

/**
 * XML Patch Framework
 */
export const xer = 'application/patch-ops-error+xml';

/**
 * XML Resource Lists
 */
export const rl = 'application/resource-lists+xml';

/**
 * XML Resource Lists
 */
export const rs = 'application/rls-services+xml';

/**
 * XML Resource Lists Diff
 */
export const rld = 'application/resource-lists-diff+xml';

/**
 * XML Transformations
 */
export const xslt = 'application/xslt+xml';

/**
 * XML-Binary Optimized Packaging
 */
export const xop = 'application/xop+xml';

/**
 * XPInstall - Mozilla
 */
export const xpi = 'application/x-xpinstall';

/**
 * XSPF - XML Shareable Playlist Format
 */
export const xspf = 'application/xspf+xml';

/**
 * XUL - XML User Interface Language
 */
export const xul = 'application/vnd.mozilla.xul+xml';

/**
 * XYZ File Format
 */
export const xyz = 'chemical/x-xyz';

/**
 * YAML Ain't Markup Language / Yet Another Markup Language
 */
export const yaml = 'text/yaml';

/**
 * YANG Data Modeling Language
 */
export const yang = 'application/yang';

/**
 * YIN (YANG - XML)
 */
export const yin = 'application/yin+xml';

/**
 * Z.U.L. Geometry
 */
export const zir = 'application/vnd.zul';

/**
 * Zip Archive
 */
export const zip = 'application/zip';

/**
 * ZVUE Media Manager
 */
export const zmm = 'application/vnd.handheld-entertainment+xml';

/**
 * Zzazz Deck
 */
export const zaz = 'application/vnd.zzazz.deck+xml';
